import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import { useGetRolesPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.form-validation';
import { GetRolesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.model';
import { useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import * as css from './role-list-filter-search-form-step-1.module.scss';

export const RoleListFilterSearchFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { control } = useFormContext<GetRolesPaginatedModel>();
    const inputRef = useRef<HTMLInputElement>(null);
    const { textToSearch } = useGetRolesPaginatedFormValidation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Controller
        name="textToSearch"
        control={control}
        rules={textToSearch}
        render={({ field /* , fieldState: { error } */ }) => {
          return (
            <TextInput
              ref={inputRef}
              className={css.searchInput}
              leftIcon="search-md"
              value={field.value}
              placeholder={t(
                'delmonicos-shared-sdk.inputs-filterable-fields-pagination.text-to-search',
              )}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              adornmentButtonType="button"
              adornmentOnClick={() => {
                field.onChange('');
                inputRef.current?.form?.requestSubmit();
              }}
              adornment={field.value !== '' && <Icon name="x-close" />}
            />
          );
        }}
      />
    );
  };
